import { render, staticRenderFns } from "./canvas_view.vue?vue&type=template&id=2fc0df18&scoped=true&"
import script from "./canvas_view.vue?vue&type=script&lang=js&"
export * from "./canvas_view.vue?vue&type=script&lang=js&"
import style0 from "./canvas_view.vue?vue&type=style&index=0&id=2fc0df18&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc0df18",
  null
  
)

export default component.exports